import React from 'react';

import PropTypes from 'prop-types';
import ReportsSection from './EventList';
import cubejs from "@cubejs-client/core";
import { strings } from 'APP_ROOT/localization';
import MyCubejsHttpTransport from "./MyCubejsHttpTransport";
import TagPermissions from '../../components/common/tagsPermissions';
import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';

export default class ReviewSection extends React.Component {

    constructor(props) {

        super(props);

        this.controller = new AbortController();

        this.state = {
            error: undefined,
            cubejsApi: undefined,
        }
    }

    componentDidMount() {
        LambdaUtil.getReportingToken(this.props.user.stage)
            .then(data => {
                const payload = JSON.parse(data.Payload);
                if (payload.status === "SUCCESS") {
                    var transport = new MyCubejsHttpTransport({
                        authorization: payload.token,
                        apiUrl: payload.apiUrl,
                        signal: this.controller.signal
                    });

                    this.setState({
                        cubejsApi: cubejs(
                            payload.token,
                            {
                                apiUrl: payload.apiUrl,
                                transport: transport
                            }
                        )
                    });

                } else {
                    console.error(payload);
                    this.setState({
                        error: 'An error occurred authenticating with the reporting system (1)'
                    });
                }
            }).catch(error => {
                console.error(error);
                this.setState({
                    error: 'An error occurred authenticating with the reporting system (2)'
                });
            });            
    }

    componentWillUnmount() {
        this.controller.abort();
    }

    shouldComponentUpdate(nextProps, nextState) {
        // If user has clicked on Apply button, we need to re-render the component
        // Else, user is just changing filters
        if(nextProps.executeQuery === true) {
            return true;
        }

        // If Cubejs is just loaded, we need to re-render the component
        if(!this.state.cubejsApi && nextState.cubejsApi) {
            return true;
        }

        // If an error occurred, we need to re-render the component
        if(this.state.error !== nextState.error) {
            return true;
        }

        return false;
    }

    render() {

        if (this.state.error) {
            return <div>{this.state.error}</div>;
        }

        if (!this.state.cubejsApi) {
            return <div>{strings.loading}</div>;
        }

        if (!this.props.executeQuery) {
            return null;
        }
        
        return (
            <ReportsSection
                error={this.state.error}
                cubejsApi={this.state.cubejsApi}
                user={this.props.user}
                selectedDateRange={this.props.selectedDateRange}
                unitOfMeasure={this.props.unitOfMeasure}
                features={this.props.features}
                facialRecognitionEnabled={this.props.facialRecognitionEnabled}
                sortOptions={this.props.sortOptions}
                onClickPrevious={this.props.onClickPrevious}
                onClickNext={this.props.onClickNext}
                eventTypesFilter={this.props.eventTypesFilter}
                driverIdsFilter={this.props.driverIdsFilter}
                vehicleNamesFilter={this.props.vehicleNamesFilter}
                eventFlagsFilterWithState={this.props.eventFlagsFilterWithState}
                setSortOptions={this.props.setSortOptions}
            />
        );
    }
}

ReviewSection.propTypes = {
    selectedDateRange: PropTypes.instanceOf(Array).isRequired,
    unitOfMeasure: PropTypes.string,
}
